<template>
    <div class='Box'>
        <!-- <Echarts/> -->
        <el-row class="Center">
            <el-col class="borde">
                <div >
                    <el-col class="bordeLeft">用户管理</el-col>
                </div>
            </el-col>
        </el-row>

        <el-row class="Center">
            <el-col class="bordedd">
                <div >
                    <el-col :span="2" class="pmn">用户手机号</el-col>
                    <el-col :span="4">
                      <el-input v-model="phone" placeholder="请输入用户手机号"></el-input>
                    </el-col>
                    <el-col :span="2" class="pmn">公司名称</el-col>
                    <el-col :span="4">
                      <el-input v-model="componey" placeholder="请输入公司名称"></el-input>
                    </el-col>
                    <el-col :span="2" class="pmn"><el-button type="primary" @click="handleGets">查询</el-button></el-col>
                </div>
            </el-col>
        </el-row>
        <!-- table -->
        <div class="table">
          <el-row >
            <el-col :span="2" ><el-button type="primary" @click="handleSetMy">发布需求</el-button></el-col>
            <el-col :span="24" v-if="showCon">
                <el-col :span='24' class="Bot" v-loading="false">
                        <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        :header-cell-style="tableHeaderColor"
                        @selection-change="handleSelectionChange"
                        >
                          <el-table-column
                            type="selection"
                            width="55">
                          </el-table-column>
                          <el-table-column
                            label="序号"
                            min-width="5%"
                            type="index"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="regeditTime"
                            min-width="10%"
                            label="注册时间"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="regeditPhone"
                            label="注册手机号"
                            min-width="10%"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="companyName"
                            label="公司名称"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="legalPersonName"
                            label="法人"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="agentName"
                            label="代理人"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="overHour"
                            label="支付渠道"
                            min-width="7%"
                            >
                            <template >
                                    <div >
                                        苏宁支付
                                    </div>
                              </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-col>

        </el-row>
        </div>
        <!-- pagination -->
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-size="pagesize"
            :total=this.totalPage>
          </el-pagination>
        </div>
    </div>
</template>

<script>


export default {
    components:{

    },
    data(){
        return{
            testData: [{
            orderNumber:'1',
            channelNumber: '4223',
            billNumber:'O2020022842231430123',
            orderStatus:'已打款',
            receive:'2220000000000000001111111111111',
            transferor:'杭州某某有限公司可换行',
            assignee:'北京某某有限公司可换行',
            reciteTime:'2.5小时',
            overTime:'00:03:34',
            times:'1',
            visible: false,
            }],
            dialogVisible:false,
            Receive:false,
            showCon:true,
            tableData:[],
            solvedDialogVisible:false,
            solvedId:'',
            totalPage:0,
            currentPage:1,
            pagesize:10,
            phone:'',
            componey:'',
            multipleSelection:[]
        }
    },
    computed: {

    },
    watch: {

    },
    mounted(){
        this.handleAjax()
    },
    methods:{
      handleCurrentChange(val) {
            this.handleAjax();
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
          if (rowIndex === 0) {
            return 'background-color: rgba(244,244,244,1);color: rgba(51,51,51,1);font-weight: bold;font-size:14px; height:55px;'
          }
        },

        handleAjax(val){
            this.loading=true
            this.ajax.post('/baseBill/userList',{bizContent:{pageNum:this.currentPage,pageSize:this.pagesize,companyName:this.componey,mobile:this.phone}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            let add = result.data.data.data
                            add.map((item,index)=>{
                                add[index].xh=index+1
                            })
                            this.tableData=add
                            this.totalPage = result.data.data.pages
                            this.loading=false
                        }else{
                            }
                        }
                )
        },
        handleGets(){
            this.handleAjax()
        },
        handleSetMy(){
          if(this.multipleSelection.length==1){
            console.log(this.multipleSelection[0].uId)
            this.$router.push({
                name:'Bilsindex',
                query:{
                  uid:this.multipleSelection[0].uId,
                  com:this.multipleSelection[0].companyName
                }
            })
          }else{
            this.$message('请选择一个用户进行发布！');
          }
        },
        handleSelectionChange(val) {
          this.multipleSelection=val
        }
    }
}
</script>

<style  scoped>
.Box{
    background: white;
    height: 883px;
}


.table{
  background:rgba(255,255,255,1);
  padding-left: 31px;
  padding-right: 38px;
}

.Bot{
      height: auto;
      height: 682px;
      background: white;
      box-shadow:0px 3px 15px 0px rgba(0,0,0,0.06);
      border-radius:8px;
}


.pagination{
  height: 111px;
  text-align: center;
  padding-top: 50px;
  box-sizing: border-box;
}

.Bot>>>.cell{
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color:rgba(51,51,51,1);
    font-family:PingFangSC-Regular,PingFang SC;
}

.button{
    padding: 12px 5px;
    border-radius: unset;
    height: 34px;
    color: #1884FC; 
    background: white;
}

.line{
  width: 920px;
  height: 1px;
  box-sizing: border-box;
  background: #E3E4E5;
  margin-left: 14px;
  margin-right: 13px;
  margin-bottom: 21px;
}

.borde{
    height: 90px;
    padding-left: 34px;
    padding-top: 38px;
}
.bordedd{
    height: 60px;
    line-height: 60px;
    padding-left: 34px;
}
.pmn{
  text-align: center;
}
.bordeLeft{
    height:33px;
    font-size:24px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:33px;
}
.bordeRight{
    text-align: right;
    padding-right: 20px;
}


.rejectBtn{
  width:56px;
  border-radius:4px;
  color: #2B89EB;
  text-align: center;
  border:1px solid #2B89EB;
}

.rejectDetail{
  border: none;
}

.rejectHeader{
  font-size:14px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(51,51,51,1);
}

.rejectReason{
  width:500px;
  height:148px;
  background:rgba(251,251,251,1);
  margin-left: 20px;
  vertical-align:top;
}
</style>


// WEBPACK FOOTER //
// src/page/orderexception/exchangeuser.vue